import * as React from 'react';

const DesignIllustrationSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="design-illustration_svg__Layer_1"
        x={0}
        y={0}
        viewBox="0 0 232 320"
        xmlSpace="preserve"
        {...props}
    >
        <style>
            {
                '\n        .design-illustration_svg__st0{fill:#121212}.design-illustration_svg__st2{fill:#1e0a3c}.design-illustration_svg__st3{fill:#fff}.design-illustration_svg__st4{fill:#f05537}.design-illustration_svg__st6{fill:#324b8c}\n    '
            }
        </style>
        <g>
            <path
                transform="rotate(-58.123 183.34 67.756)"
                className="design-illustration_svg__st0"
                d="M180 67.4h6.6v.6H180z"
            />
            <path
                transform="rotate(-83.61 177.724 66.037)"
                className="design-illustration_svg__st0"
                d="M174.8 65.7h5.8v.6h-5.8z"
            />
            <path
                transform="rotate(-32.478 187.307 72.043)"
                className="design-illustration_svg__st0"
                d="M184.4 71.7h5.8v.6h-5.8z"
            />
            <path
                d="M0 235.4c18.3-2.4 47.9-4 81.5-4 55.7 0 100.9 4.3 100.9 9.5s-45.2 9.5-100.9 9.5c-33.7 0-63.2-1.6-81.5-4"
                fill="#dbdae3"
            />
            <path
                className="design-illustration_svg__st2"
                d="M59.7 228.6c1-2.2 1.5-18.2 1.5-18.2l19.4-.2 19.5.2s.5 15.9 1.6 18.2 10.8 7.3 8.8 8.6c-1.8 1.2-57.9 1.2-59.7 0-2.1-1.3 7.8-6.3 8.9-8.6zM0 192.7V76.1h174.6c2.2 0 4 1.8 4 4v112.5H0z"
            />
            <path
                className="design-illustration_svg__st2"
                d="M178.7 192.5v14.1c0 2.2-1.8 4-4 4H0v-18.2"
            />
            <path
                className="design-illustration_svg__st3"
                d="M0 83.2h171v102.4H0z"
            />
            <path
                className="design-illustration_svg__st3"
                d="M0 102.1h171v83.6H0z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M0 83.2h171v6.1H0z"
            />
            <circle
                className="design-illustration_svg__st2"
                cx={167.8}
                cy={86.4}
                r={1.5}
            />
            <circle
                className="design-illustration_svg__st2"
                cx={163.2}
                cy={86.4}
                r={1.5}
            />
            <circle
                className="design-illustration_svg__st2"
                cx={158.7}
                cy={86.4}
                r={1.5}
            />
            <path
                className="design-illustration_svg__st3"
                d="M112.3 254.9l-10.4-3.9-1 5.8 11.1-.1"
            />
            <path d="M112 256.7h4.1c.2 0 .3-.2 0-.3l-3.9-1.5" fill="#f6682f" />
            <path
                className="design-illustration_svg__st3"
                d="M22.5 236.7l-4.2-.8c-.5-.1-1 .1-1 .4l-.8 4.6c0 .4.3.7.8.8l4.2.8 1-5.8z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M21.5 242.5l79.4 14.3 1-5.8-79.4-14.3zM11.7 109.6h74.6v44.9H11.7z"
            />
            <path
                className="design-illustration_svg__st3"
                d="M18.6 117.4h28.3v1.8H18.6zM18.6 124.8h59.1v3.7H18.6zM18.6 131.6h59.1v3.7H18.6zM18.6 138.3h49v3.7h-49z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M12.9 168.2h18.2c.5 0 1 .4 1 1v5.3c0 .5-.4 1-1 1H12.9c-.5 0-1-.4-1-1v-5.3c0-.5.5-1 1-1z"
            />
            <path
                className="design-illustration_svg__st6"
                d="M136.7 206.4h24.8v22.7c0 4.9-4 9-9 9h-6.8c-4.9 0-9-4-9-9v-22.7z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M150.1 235h-.8c-1.4-.2-2.6-1.1-3.1-2.4-.4-1 0-2.3 1.1-3.2.9-.8 4.1-2.7 10.7.1.5-.5 1-1.1 1.5-1.7 3.5-4.2 5.8-8.4 6.4-12.3.6-3.4 0-6.3-1.7-8.3-2.9-3.3-8.3-3.1-14 .7l-.6-.9c3.1-2 6.3-3.1 9-3.1 2.6 0 4.9.9 6.4 2.7 3.5 4 3.4 12.3-4.7 22-.4.5-.9 1-1.3 1.5 1 .4 1.9 1 2.9 1.6 4.9 2.9 8.7 1.7 10.5.6 2.4-1.3 4-3.7 4-5.7h1c0 2.4-1.8 5.1-4.6 6.6-3.5 1.9-7.7 1.7-11.6-.6-1-.6-2-1.2-3.1-1.7-3.5 3.3-6.2 4.1-8 4.1zm1.7-6.1c-1.7 0-2.9.4-3.8 1.1-.9.7-1 1.5-.9 2 .4 1 1.3 1.7 2.3 1.8 2.1.4 4.9-1 7.7-3.7-1.6-.7-3.4-1.1-5.3-1.2z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M176.6 220.5c-.9-.9-2.2-1.2-3.3-.9.8.7.8 1.8 1.2 2.8.3.9 1.7 3.1 2.9 2.2 1.2-.8 0-3.4-.8-4.1zM146.5 206.1c-6.2 1.5-9.1-4.3-9.4-16.7 10.5 2.2 19.7 14.2 9.4 16.7z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M146.6 193.5c.6-2.7 1.8-5.1 3.5-7.3 1.6-2 3.6-3.6 5.6-5.2 1.4 3.2 2.7 6.5 3.7 9.9.9 2.9 1.7 6.1.5 8.9-4.3 10.4-15.3 2.9-13.3-6.3z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M147.4 203.7c-.5.4-.9 1-1.3 1.5-1.6 2-3.3 3.8-5.3 5.4 2.2.8 4.6 1.1 7 1 2.7-.1 7.2-2.5 6.9-5.8-.4-3.2-5.1-4-7.3-2.1z"
            />
            <path
                transform="translate(-.252 .076)"
                className="design-illustration_svg__st4"
                d="M47.5 159.8h1.6v1h-1.6z"
            />
            <path
                className="design-illustration_svg__st4"
                d="M16.5 160.9v-1h2.9v1h-2.9zm6.2 0v-1h2.9v1h-2.9zm6.2 0v-1h2.9v1h-2.9zm6.2 0v-1H38v1h-2.9zm6.2 0v-1h2.9v1h-2.9z"
            />
            <path
                transform="translate(-.196 .015)"
                className="design-illustration_svg__st4"
                d="M11.7 159.8h1.6v1h-1.6z"
            />
            <path
                className="design-illustration_svg__st6"
                d="M101.3 68.1h32.8v75.7h-32.8zM149.9 95.6H232v70.2h-82.1z"
            />
            <g>
                <path
                    className="design-illustration_svg__st4"
                    d="M214.3 175.8h-96.6c-.3 0-.5-.2-.5-.5v-57.4c0-.3.2-.5.5-.5h96.6c.3 0 .5.2.5.5v57.4c0 .2-.2.5-.5.5zm-96.1-1.1h95.6v-56.4h-95.6v56.4z"
                />
                <path
                    transform="rotate(-30.717 165.798 146.58)"
                    className="design-illustration_svg__st4"
                    d="M109.6 146.1h112.3v1H109.6z"
                />
                <path
                    transform="rotate(-59.283 165.825 146.472)"
                    className="design-illustration_svg__st4"
                    d="M165.3 90.3h1v112.3h-1z"
                />
            </g>
        </g>
    </svg>
);

DesignIllustrationSvg.displayName = 'DesignIllustrationSvg';
export default DesignIllustrationSvg;
